import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    liquidacionesSueldos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    periodoDesde: moment(new Date()).add(-90, 'days').format('YYYY-MM-DD'),
    periodoHasta: moment(new Date()).format('YYYY-MM-DD'),
    sortByDescending: false,

    rptEvolucionSueldos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.liquidacionesSueldos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.periodoDesde = moment(new Date()).add(-90, 'days').format('YYYY-MM-DD');
        state.periodoHasta = moment(new Date()).format('YYYY-MM-DD');
        state.sortByDescending = false;
    },

    'INICIALIZAR_LIQUIDACIONES_SUELDOS' (state) {
        state.liquidacionesSueldos = [];
    },
    'SET_LIQUIDACIONES_SUELDOS' (state, liquidacionesSueldos) {
        state.liquidacionesSueldos = liquidacionesSueldos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_RPT_EVOLUCION_SUELDOS'(state) {
        state.rptEvolucionSueldos = [];
    },
    'SET_RPT_EVOLUCION_SUELDOS'(state, rptEvolucionSueldos) {
        state.rptEvolucionSueldos = rptEvolucionSueldos;
    },
};

const getters = {
    getField,

    rptEvolucionSueldos(state) {
        return state.rptEvolucionSueldos;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getLiquidacionesSueldos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIQUIDACIONES_SUELDOS');

            /* Convertimos las fecha a formato periodo */
            let periodoDesdeMes= moment(state.periodoDesde).month() + 1;
            let periodoDesdeMesNombre= helpers.methods.getMesNombre(periodoDesdeMes);
            let periodoDesdeAnio= moment(state.periodoDesde).year();
            let periodoDesde = parseInt(periodoDesdeAnio).toString().trim()
                + '-' + helpers.methods.getMesNumeroToString(periodoDesdeMesNombre).toString().trim()
                + '-01';

            let periodoHastaMes= moment(state.periodoHasta).month() + 1;
            let periodoHastaMesNombre= helpers.methods.getMesNombre(periodoHastaMes);
            let periodoHastaAnio= moment(state.periodoHasta).year();
            let periodoHasta = parseInt(periodoHastaAnio).toString().trim()
                + '-' + helpers.methods.getMesNumeroToString(periodoHastaMesNombre).toString().trim()
                + '-01';
  
            let queryString = '?fechaDesde='+ periodoDesde
                + '&fechaHasta='+ periodoHasta
                + '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            // let queryString = '?fechaDesde='+ moment.utc(state.periodoDesde).format('YYYY-MM-DD')
            //     + '&fechaHasta='+ moment.utc(state.periodoHasta).format('YYYY-MM-DD')
            //     + '&pageSize=' + state.registrosPorPagina
            //     + '&pageNumber=' + state.paginaActual;

            apiAxios.get('liquidaciones-sueldos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_LIQUIDACIONES_SUELDOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, liquidacionSueldosId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`liquidaciones-sueldos/${liquidacionSueldosId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getRptEvolucionSueldos: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_EVOLUCION_SUELDOS')
            
            let queryString = '?fechaDesde=' + params.fechaDesde
                + '&fechaHasta=' + params.fechaHasta;
            
            if (params.personalId != 0) {
                queryString += '&personalId=' + params.personalId;
            }

            apiAxios.get('liquidaciones-sueldos/rpt/evolucion-sueldos' + queryString)
                .then(res => {
                    commit('SET_RPT_EVOLUCION_SUELDOS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}